// Browsers fire "ResizeObserver loop completed with undelivered notifications"
// when observed elements resize during a resize callback (the SVAR Gantt's
// dynamic timescale does this). The notification is benign per spec, but the
// CRA dev overlay reports it as an uncaught runtime error. Deferring callbacks
// to the next animation frame prevents the loop from ever being detected.
//
// Patched globally rather than around the Gantt's own mount because the class
// has to be replaced before any third-party code constructs an observer; every
// observer in the app is therefore deferred by a frame, which is safe because
// notifications are already delivered asynchronously.
const installResizeObserverLoopFix = () => {
	const NativeResizeObserver = window.ResizeObserver;
	if (!NativeResizeObserver) return;

	window.ResizeObserver = class extends NativeResizeObserver {
		constructor(callback) {
			super((entries, observer) => {
				window.requestAnimationFrame(() => callback(entries, observer));
			});
		}
	};
};

export default installResizeObserverLoopFix;
